import { Card, CardContent, Skeleton } from '@billda/design-system';
import type { ReactNode } from 'react';

interface MetricCardProps {
  label: string;
  value: string;
  icon: ReactNode;
  /** Semantic token classes applied to the icon tile (text + soft surface). */
  iconClassName: string;
  isLoading?: boolean;
  testId?: string;
}

export function MetricCard({
  label,
  value,
  icon,
  iconClassName,
  isLoading,
  testId,
}: MetricCardProps) {
  return (
    <Card
      data-testid={testId}
      className="h-full transition-colors duration-200 hover:border-border-strong hover:shadow-card"
    >
      <CardContent className="p-2">
        <div className="flex items-center gap-1.5">
          <div
            className={`flex size-10 shrink-0 items-center justify-center rounded-[10px] [&_svg]:size-[22px] ${iconClassName}`}
          >
            {icon}
          </div>
          <div className="min-w-0">
            {isLoading ? (
              <>
                <Skeleton width={80} height={16} className="mb-0.5" />
                <Skeleton width={100} height={28} />
              </>
            ) : (
              <>
                <span className="block type-caption leading-[1.2] text-content-secondary">
                  {label}
                </span>
                <span className="block type-h6 leading-[1.3] font-bold">
                  {value}
                </span>
              </>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
